export const iconFontAwesomeSportsFitnessFireFlameCurved = (
	<i className="fa-solid fa-fire-flame-curved"></i>
);
